module.exports = __webpack_public_path__ + "media/images/area/map_cities_sp-020ddfcdd30d635eb7525da986edfae1.png";